<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增授权码
      </el-button>
      <div class="former">
        <el-input
          v-model="form['Name:like']"
          placeholder="授权码"
          @keydown.enter.native="onSubmitQuery"
        ></el-input>&nbsp;
        <el-select v-model="form.BusinessType" clearable placeholder="业务类型">
          <el-option
            v-for="item in businessType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>&nbsp;
        <el-select v-model="form.Version" clearable placeholder="请选择功能版本">
          <el-option
            v-for="item in version"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>&nbsp;
        <select2
          v-model="form.PlatformID"
          url="platform"
          labelName="PlatformName"
          placeholder="请选择平台名称"
          no-data-text="无平台"
        ></select2>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)"
      ></el-table-column>
      <el-table-column label="业务类型">
        <template slot-scope="scope">
          <div v-if="scope.row.BusinessType==1">业务类型1</div>
          <div v-if="scope.row.BusinessType==2">业务类型2</div>
          <div v-if="scope.row.BusinessType==3">业务类型3</div>
        </template>
      </el-table-column>
      <el-table-column prop="Software.Name" label="软件名称"></el-table-column>
      <el-table-column label="功能版本">
        <template slot-scope="scope">
          <div v-if="scope.row.FunctionVersion==1">版本1</div>
          <div v-if="scope.row.FunctionVersion==2">版本2</div>
          <div v-if="scope.row.FunctionVersion==3">版本3</div>
        </template>
      </el-table-column>
      <el-table-column prop="Name" label="授权码"></el-table-column>
      <el-table-column prop="BindRecordsCount" label="使用次数"></el-table-column>
      <el-table-column label="当前绑定日期">
        <template slot-scope="scope">
          <div v-if="scope.row.Station && scope.row.Station.UpdatedAt">
            {{scope.row.Station.UpdatedAt.substring(0,10)}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="Station.Name" label="当前绑定站点"></el-table-column>
      <el-table-column width="200" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="showRecord(scope.row)">使用记录</el-button>
          <el-button type="danger" @click.stop="onDeleteItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <record v-model="item" :visible.sync="recordVisible"/>
    <create-code v-model="item" :visible.sync="itemVisible" @form:saved="getItemList"/>
  </el-card>
</template>

<script>
import CreateCode from './createCode.vue';
import Record from './record.vue';

export default {
  components: {
    CreateCode,
    Record,
  },
  data() {
    return {
      businessType: [
        {
          value: 1,
          label: '业务类型1',
        },
        {
          value: 2,
          label: '业务类型2',
        },
        {
          value: 3,
          label: '业务类型3',
        },
      ],
      version: [
        {
          value: 1,
          label: '版本1',
        },
        {
          value: 2,
          label: '版本2',
        },
        {
          value: 3,
          label: '版本3',
        },
      ],
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        'Name:like': '',
        Version: '',
        BusinessType: '',
        PlatformID: '',
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      recordVisible: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    // 获取
    getItemList() {
      this.loading = true;
      this.$axios
        .get('ipccode', {
          params: {
            where: this.form,
            with: ['Platform', 'IpcDevice', 'BindRecords/count'],
            ...this.pager,
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, 'size', 'page', 'total');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 编辑
    showRecord(row) {
      this.item = row;
      this.recordVisible = true;
    },
    // 删除
    onDeleteItem(row) {
      this.$confirm('确定要删除该授权码吗？', '提示')
        .then(() => this.$axios.delete(`code/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success('成功删除');
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 新增
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.itemVisible = true;
    },
    // item置空
    getEmptyItem() {
      return {};
    },
  },
};
</script>
